<template>
  <!-- Authors Table Card -->
  <a-card
    :bordered="false"
    class="header-solid h-full"
    :bodyStyle="{ padding: '0 20px' }"
  >
    <div class="seareh_box">
      <a-form layout="inline" :form="form" >
        <a-form-item>
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="time" />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="getBalancerecord"> 查询 </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :pagination="pagination"
      :data-source="tableData"
      @change="tableChange"
    >
      <span slot="key" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">
          扣费成功
        </a-tag>
        <a-tag v-else color="red">
          扣费失败
        </a-tag>
      </div>
      
    </a-table>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import {getBalancerecord} from '@/api/user'
const table1Columns = [
  {
    title: "序号",
    dataIndex: "key",
    scopedSlots: { customRender: "key" },
  },
  {
    title: "调用订单号",
    dataIndex: "orderSn",
    scopedSlots: { customRender: "orderSn" },
  },
  {
    title: "使用时间",
    dataIndex: "deductTime",
  },
  {
    title: "姓名",
    dataIndex: "userName",
    scopedSlots: { customRender: "userName" },
  },
  {
    title: "身份证号",
    dataIndex: "idCardNumber",
    
  },
  {
    title: "扣费结果",
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "消耗次数",
    dataIndex: "deductAmount",
  },


  {
    title: "扣除后余额",
    dataIndex: "balanceAfterDeduction",
  },
];


function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  data() {
    return {
      columns: table1Columns,
      tableData: [],
      time:[],
      pagination: {
        showQuickJumper: true,
        showSizeChanger: true,
        total: 3,
        pageSize: 10,
        current: 1,
      },
      // Active button for the "Authors" table's card header radio button group.
      hasErrors,
      form: this.$form.createForm(this, { name: "horizontal_login" }),
    };
  },
  mounted() {
    this.pagination.current = 1
    this.getBalancerecord()
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    
    });
  },
  methods: {
    handleSubmit(){
      this.pagination.current = 1
      this.getBalancerecord()
    },
    getBalancerecord(){
      getBalancerecord({
        startCreateTime: this.time[0] || '',
        endCreateTime: this.time[1]|| '',
        current: this.pagination.current,
        size: this.pagination.pageSize
      }).then(res => {
        this.tableData = res.records
        this.pagination.total = res.total
      })

    },

    tableChange(e) {
       this.pagination.current = e.current
      this.pagination.pageSize = e.pageSize
      this.getBalancerecord()
    },
    // Only show error after a field is touched.
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.seareh_box {
  padding: 20px 10px;
}
</style>
